import React, { useEffect } from "react"
import { Link } from "react-router-dom"
import VincePortrait from "../assets/images/vince.jpeg"
import "./ThankYou.css"

const ThankYou = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className='thankyou-page'>
      <div className='thankyou-container'>
        <header className='thankyou-header'>
          <h1>One Last Thing</h1>
        </header>

        <section className='step step-video'>
          <div className='step-id'>Step 1</div>
          <div className='step-copy'>
            <h2>Watch the Prep Video</h2>
            <p>
              This 6-minute overview walks you through the Cordova Franchising
              platform, revenue model, and launch plan so we can dive straight
              into your market when we meet.
            </p>
          </div>
          <div className='video-frame'>
            <iframe
              src='https://player.vimeo.com/video/1135783095?h=0a8b7d3e99&title=0&byline=0&portrait=0&badge=0&dnt=1'
              title='Cordova Franchising Prep Video'
              frameBorder='0'
              allow='autoplay; fullscreen; picture-in-picture'
              allowFullScreen
            ></iframe>
          </div>
          <div className='presenter-note'>
            <span className='presenter-name'>Hosted by Joe Crawford</span>
            <span className='presenter-role'>Franchise Development</span>
          </div>
        </section>

        <section className='step step-snapshot'>
          <div className='step-id'>Step 2</div>
          <div className='step-copy'>
            <h2>Open the Franchise Snapshot</h2>
            <p>
              Grab the one-page overview we just uploaded. It breaks down gross
              sales, average ticket size, EBITDA performance, start-up costs,
              and the profile of our top-performing owners, perfect prep before
              we talk through your territory.
            </p>
          </div>
          <ul className='snapshot-highlights'>
            <li>$13.7M flagship gross sales with 14.8% EBITDA margins</li>
            <li>
              National contracts, nearshore teams, and ready-to-deploy tech
              stack
            </li>
            <li>Clear investment range, franchise fee, and owner checklist</li>
          </ul>
          <a
            className='download-link'
            href='https://www.cordovafranchising.com/C-00-One%20Pagers.pdf'
            target='_blank'
            rel='noopener noreferrer'
          >
            Open the Franchise Snapshot (PDF)
          </a>
        </section>

        <section className='step-grid'>
          <div className='step step-podcast'>
            <div className='step-id'>Step 3</div>
            <div className='step-copy'>
              <h2>Listen to the Podcast Primer</h2>
              <p>
                A 15-minute conversation that covers the backstory, numbers, and
                what to expect as an owner. Give it a listen before we talk.
              </p>
            </div>
            <div className='podcast-embed'>
              <iframe
                src='https://open.spotify.com/embed/episode/1TsPzB4wsbEedpdxEk8Tk1?utm_source=generator'
                allow='autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture'
                loading='lazy'
                title='Cordova Franchising Podcast Primer'
              ></iframe>
            </div>
            <a
              className='podcast-link'
              href='https://open.spotify.com/episode/1TsPzB4wsbEedpdxEk8Tk1?si=zqFJDctpQ0CFrGFsME0HiQ'
              target='_blank'
              rel='noopener noreferrer'
            >
              Open in Spotify
            </a>
          </div>

          <div className='step step-ceo'>
            <div className='step-id'>From Vince</div>
            <div className='ceo-card'>
              <img src={VincePortrait} alt='Vince Cordova' />
              <div className='ceo-copy'>
                <h3>You’re meeting with me</h3>
                <p>
                  "Watch the prep pieces above so we can focus our time on your
                  territory, goals, and the fastest path to building your firm."
                </p>
                <span className='ceo-name'>— Vince Cordova, CEO</span>
              </div>
            </div>
            <div className='ceo-links'>
              <a
                href='https://www.linkedin.com/in/vincent-cordova/'
                target='_blank'
                rel='noopener noreferrer'
              >
                Connect on LinkedIn
              </a>
              <a
                href='https://cordova.com'
                target='_blank'
                rel='noopener noreferrer'
              >
                Visit cordova.com
              </a>
            </div>
            <Link to='/booking' className='back-home'>
              ← Back to Homepage
            </Link>
          </div>
        </section>
      </div>
    </div>
  )
}

export default ThankYou
